import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const HomepageIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M10 20.5V14.5H14V20.5H19V12.5H22L12 3.5L2 12.5H5V20.5H10Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default HomepageIcon;
